import React, { useEffect, useState } from 'react'
import { Box, Image, Stack } from '@chakra-ui/react'
import Logo from "../../assets/images/app_logo.svg";
import DashboardIcon from '../../assets/images/dashboardBorrower.svg';
import DashboardWhiteIcon from '../../assets/images/dashboardBorrowerWhite.svg';
import BorrowerIcon from '../../assets/images/borrower.svg';
import BorrowerWhiteIcon from '../../assets/images/borrowerWhite.svg';
import LenderIcon from '../../assets/images/lender.svg';
import LenderWhiteIcon from '../../assets/images/lenderWhite.svg';
import PayoutIcon from '../../assets/images/payout.svg';
import PayoutWhiteIcon from '../../assets/images/payoutWhite.svg';
import LoanStatusIcon from '../../assets/images/loanStatus.svg';
import LoanStatusWhiteIcon from '../../assets/images/loanStatusWhite.svg';
import * as routesNames from '../../constants/routes'
import { Link, useLocation } from 'react-router-dom'
import { ChevronDownIcon } from '@chakra-ui/icons';
import BlackCollectionIcon from '../../assets/images/blackcollection.svg';
import UserCollectionIcon from '../../assets/images/collectionWhite.svg';

const menus = [
  {
    id: 1,
    menuName: 'Dashboard',
    link: routesNames.CPDASHBOARD,
    menuIcon: DashboardIcon,
    menuIconActive: DashboardWhiteIcon,
  },
  {
    id: 2,
    menuName: 'My Borrowers',
    link: routesNames.CPBORROWERS,
    menuIcon: BorrowerIcon,
    menuIconActive: BorrowerWhiteIcon,
  },
  {
    id: 3,
    menuName: 'Loan List',
    link: routesNames.CPLOANLIST,
    menuIcon: LoanStatusIcon,
    menuIconActive: LoanStatusWhiteIcon,
  },
  {
    id: 4,
    menuName: 'My Investors',
    link: routesNames.CPINVESTORS,
    menuIcon: LenderIcon,
    menuIconActive: LenderWhiteIcon,
  },
  {
    id: 5,
    menuName: 'My Payouts',
    link: routesNames.CPPAYOUTS,
    menuIcon: PayoutIcon,
    menuIconActive: PayoutWhiteIcon,
  }, {
    id: 6,
    menuName: 'Collections',
    link: routesNames.CPPCOLLECTIONS,
    menuIcon: BlackCollectionIcon,
    menuIconActive: UserCollectionIcon,
  }
]

export default function SidebarCP() {

  const location = useLocation();
  const [menuId, setMenuId] = useState(null)  

  useEffect(() => {
    const menuItem = menus.find((item) => item.link === location.pathname);
    if (menuItem) {
        setMenuId(menuItem.id);
    }
  }, [location.pathname]);
  
  const handleMenu = (item) => {
      setMenuId(item)
  }

  return (
    <Box className='sidebar_wrapper'>
      <Link to={routesNames.BORROWERDASHBOARD}>
       <Image src={Logo} alt='logo' className='app_logo' />
      </Link>
      <Stack className="menu_box">
        {menus?.map((item) => {
          return (
            <>
              <Link key={item.id} to={item.link} onClick={() => handleMenu(item.id)}
                className={item.id === menuId ? 'active_menu_item menu_item font-poppins' : 'menu_item font-poppins'} >
                <Image src={item.id === menuId ? item.menuIconActive : item.menuIcon} className="icon_size" />
                  {item.menuName}
                  {/* {item.subMenu &&
                    <Box className='submenu_icon'>
                      <ChevronDownIcon />
                    </Box> */}
              </Link>
              {/* {item?.subMenu?.map((elem) => {
                return (
                  <Box className='sub_menu'>
                    <Link key={elem.id} to={elem.link} onClick={() => handleMenu(elem.id)}
                      className={elem.id === menuId ? 'active_menu_item menu_item font-poppins' : 'menu_item font-poppins'} >
                      <Image src={elem.id === menuId ? elem.menuIconActive : elem.menuIcon} className="icon_size" />
                        {elem.menuName}
                    </Link>
                </Box>
                )
              })} */}
            </>
          )
        })}
      </Stack>
    </Box>
  )
}
